import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class Viewer3D extends VisualComponent {
    getType() { return "Viewer3D"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab );
        if( prefab.getURL() ) {
            var model3D =  MediaManager.getMedia(prefab.getURL());

            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            this.mesh.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, 
                function(event){
                    var event = new CustomEvent("openViewer3D",{detail:{
                        meshURL: model3D.getURL(), 
                        scaleX: prefab.getScaleX(),
                        scaleY: prefab.getScaleY(),
                        scaleZ: prefab.getScaleZ(),
                        name: prefab.getName(),
                    }});
                    window.dispatchEvent(event);
                })
            );
            
        }

        return base;
    }
    
}

export default Viewer3D;
